@if (totalPages && totalPages > 1) {
  <pagination-controls
    class="table-pagination text-base font-semibold leading-base"
    (pageChange)="pageChange.emit($event)"
    [maxSize]="6"
    [ngClass]="{ 'hide-previous': currentPage === 1, 'hide-next': currentPage === totalPages }"
  >
  </pagination-controls>
}
